var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('ModalBasicInfo',{attrs:{"show":!_vm.hasNickname},on:{"submit":_vm.onBasicInfoSubmit,"close":_vm.close}}),_c('ModalRankTest',{attrs:{"show":_vm.hasNickname && !_vm.hasRank && !_vm.isRankTestClosed && !_vm.pendingPrize,"initial-selected":_vm.initialSelected},on:{"close":_vm.onRankTestClose}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }